// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/fuelSurcharge.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9440: ONE fuel surcharge calculation — the server line pass and
// billing.js Review.)
//
// Side-effect module: attaches `window.FuelSurcharge`. billing.js reads it at
// CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  const FUEL_SURCHARGE_TYPE = "FUEL_SURCHARGE";
  const FUEL_SURCHARGE_LINE_ID = "fuel_surcharge";
  // tickets/{id}/fuelSurchargeStamp/current — SERVER-ONLY (no rules match, so
  // clients are default-denied). The authoritative stamp for a frozen ticket.
  const FUEL_SURCHARGE_STAMP_COLLECTION = "fuelSurchargeStamp";
  const FUEL_SURCHARGE_CATEGORY_KEYS = ["equipment", "labor", "permits", "fieldItems", "misc", "standby", "downtime"];

  function normalizeFuelSurchargePercent(v) {
    // A number or a numeric string only: true, [12] or {} are not a percent.
    if (typeof v !== "number" && !(typeof v === "string" && v.trim() !== "")) return null;
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0 || n > 100) return null;
    // Whole hundredths of a percent; anything that rounds to 0% is no surcharge.
    const r = Math.round(n * 100) / 100;
    return r > 0 ? r : null;
  }

  function normalizeFuelSurchargeConfig(raw, fallback) {
    if (!raw || typeof raw !== "object") return null;
    if (raw.mode === "off") return { mode: "off" };
    if (raw.mode !== "flat") return null;
    const percent = normalizeFuelSurchargePercent(raw.percent);
    if (percent === null) return null;
    const fb = fallback && typeof fallback === "object" ? fallback : {};
    const srcCats = (raw.categories && typeof raw.categories === "object") ? raw.categories
      : ((fb.categories && typeof fb.categories === "object") ? fb.categories : { equipment: true });
    const categories = {};
    for (const k of ["equipment", "labor", "permits", "fieldItems", "misc", "standby", "downtime"]) {
      if (srcCats[k] === true) categories[k] = true;
    }
    if (Object.keys(categories).length === 0) return null;
    const taxable = (raw.taxable === true || raw.taxable === false) ? raw.taxable : fb.taxable === true;
    return { mode: "flat", percent, categories, taxable };
  }

  function resolveFuelSurchargeConfig(fs, customerId, contractId) {
    const s = fs && typeof fs === "object" ? fs : {};
    const company = normalizeFuelSurchargeConfig(s, null);
    const fb = company && company.mode === "flat" ? company : { categories: s.categories, taxable: s.taxable };
    const books = s.priceBooks && typeof s.priceBooks === "object" ? s.priceBooks : {};
    const custs = s.customers && typeof s.customers === "object" ? s.customers : {};
    if (contractId && Object.prototype.hasOwnProperty.call(books, contractId)) {
      const b = normalizeFuelSurchargeConfig(books[contractId], fb);
      if (b) return Object.assign({ source: "price_book", contractId }, b);
    }
    if (customerId && Object.prototype.hasOwnProperty.call(custs, customerId)) {
      const c = normalizeFuelSurchargeConfig(custs[customerId], fb);
      if (c) return Object.assign({ source: "customer", contractId: null }, c);
    }
    if (company) return Object.assign({ source: "company_default", contractId: null }, company);
    return { mode: "off", source: "none", contractId: null };
  }

  function fuelSurchargeBase(lines, categories, categoryFn, billableFn) {
    const cats = categories && typeof categories === "object" ? categories : {};
    let sum = 0;
    for (const l of (lines || [])) {
      if (!l || l.type === "FUEL_SURCHARGE") continue;
      if (l.includeOnInvoice === false) continue;
      const cat = categoryFn(l.type);
      if (cat === null || cats[cat] !== true) continue;
      sum += (cat === "downtime" ? -1 : 1) * billableFn(l);
    }
    return Math.round(sum * 100) / 100;
  }

  function fuelSurchargeAmount(base, pct) {
    const b = Number(base) || 0;
    const p = Number(pct) || 0;
    if (!(b > 0) || !(p > 0)) return 0;
    return Math.round(Math.round(b * 100) * p / 100) / 100;
  }

  function fuelSurchargeMoneyText(n) {
    const cents = Math.round((Number(n) || 0) * 100);
    const neg = cents < 0;
    const abs = Math.abs(cents);
    const whole = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const frac = String(abs % 100).padStart(2, "0");
    return (neg ? "-$" : "$") + whole + "." + frac;
  }

  function fuelSurchargeDescription(pct, base, categories) {
    const labels = { equipment: "equipment", labor: "labor", permits: "permits", fieldItems: "field items", misc: "misc", standby: "standby", downtime: "downtime" };
    const cats = categories && typeof categories === "object" ? categories : {};
    const on = ["equipment", "labor", "permits", "fieldItems", "misc", "standby", "downtime"].filter((k) => cats[k] === true).map((k) => labels[k]);
    const what = on.length === 0 ? "charges" : on.length === 1 ? on[0] : on.slice(0, -1).join(", ") + " and " + on[on.length - 1];
    return "Fuel Surcharge " + String(Number(pct) || 0) + "% of " + fuelSurchargeMoneyText(base) + " " + what;
  }

  function fuelSurchargeTicketState(t) {
    if (!t || typeof t !== "object") return "closed";
    if (t.invoiced === true || !!t.invoiceNumber || !!t.invoicedAt) return "closed";
    if (["invoiced", "archived", "deleted", "locked"].includes(t.status)) return "closed";
    if (t.writtenOff === true || t.splitFrom || t.ticketCustomerResponse === "accepted") return "settled";
    if (["sent", "qbSynced", "paid"].includes(t.status)) return "settled";
    if (t.status !== "draft") return "frozen";
    if (t.ticketSendLastAt || t.ticketEmailSentAt || t.ticketCustomerResponse) return "frozen";
    return "open";
  }

  function fuelSurchargeLineFields(cfg, base, amount) {
    const cats = {};
    for (const k of ["equipment", "labor", "permits", "fieldItems", "misc", "standby", "downtime"]) {
      if (cfg.categories && cfg.categories[k] === true) cats[k] = true;
    }
    return {
      type: "FUEL_SURCHARGE",
      description: fuelSurchargeDescription(cfg.percent, base, cats),
      quantity: 1,
      rateUnit: "ea",
      rate: amount,
      lineAmount: amount,
      includeOnInvoice: true,
      // Revenue by category (BI chart, the connector's revenue summary) buckets on
      // the stored line's revenueCategory; without it the surcharge reads
      // "Uncategorized" and the chart drops it.
      revenueCategory: "Fuel Surcharge",
      fuelSurchargeMode: "flat",
      fuelSurchargePercent: cfg.percent,
      fuelSurchargeBase: base,
      fuelSurchargeCategories: cats,
      fuelSurchargeTaxable: cfg.taxable === true,
      fuelSurchargeSource: cfg.source || null,
      fuelSurchargeContractId: cfg.contractId || null,
      source: "fuel_surcharge",
      sortOrder: 9000,
    };
  }

  function fuelSurchargeLineMatches(line, want) {
    if (!line || !want) return false;
    for (const k of Object.keys(want)) {
      if (JSON.stringify(line[k] === undefined ? null : line[k]) !== JSON.stringify(want[k])) return false;
    }
    return true;
  }

  function planFuelSurcharge(ticket, lines, resolved, categoryFn, billableFn, stamp) {
    const state = fuelSurchargeTicketState(ticket);
    const out = { state, changed: false, set: null, deleteIds: [], before: null, after: null };
    if (state === "closed") return out;
    if (state === "settled" && stamp === undefined) return out;
    const all = (lines || []).filter((l) => l && typeof l === "object");
    const fuel = all.filter((l) => l.type === "FUEL_SURCHARGE")
      .sort((a, b) => (a.id === "fuel_surcharge" ? 0 : 1) - (b.id === "fuel_surcharge" ? 0 : 1) || String(a.id || "").localeCompare(String(b.id || "")));
    const keep = fuel.length ? fuel[0] : null;
    let cfg = null;
    if (state === "open") {
      if (resolved && resolved.mode === "flat" && normalizeFuelSurchargePercent(resolved.percent) !== null) {
        cfg = { percent: normalizeFuelSurchargePercent(resolved.percent), categories: resolved.categories || { equipment: true }, taxable: resolved.taxable === true, source: resolved.source || null, contractId: resolved.contractId || null };
      }
    } else {
      const src = stamp === undefined ? keep : stamp;
      if (src) {
        const p = normalizeFuelSurchargePercent(src.fuelSurchargePercent);
        if (p !== null) {
          cfg = { percent: p, categories: src.fuelSurchargeCategories || { equipment: true }, taxable: src.fuelSurchargeTaxable === true, source: src.fuelSurchargeSource || null, contractId: src.fuelSurchargeContractId || null };
        } else if (stamp === undefined) {
          return out;
        }
      }
    }
    out.before = keep ? { percent: keep.fuelSurchargePercent === undefined ? null : keep.fuelSurchargePercent, lineAmount: Number(keep.lineAmount) || 0, taxable: keep.fuelSurchargeTaxable === true, categories: keep.fuelSurchargeCategories || null, base: keep.fuelSurchargeBase === undefined ? null : keep.fuelSurchargeBase } : null;
    let want = null;
    if (cfg) {
      const base = fuelSurchargeBase(all, cfg.categories, categoryFn, billableFn);
      if (state === "settled") {
        // Pre-deploy COD (Code Reviewer + Domain): on a settled ticket the SERVER
        // stamp's recorded base is the only authority, never the current base lines
        // (staff can still edit those here) and never the line's own recorded base.
        // A forged, hidden or deleted surcharge line is restored at the stamped base,
        // so the surcharge cannot move after acceptance / sending. Only a stamp with
        // no recorded base (this code always writes one) falls back to the lines.
        const sbRaw = stamp ? stamp.fuelSurchargeLineBase : null;
        const sb = sbRaw === null || sbRaw === undefined || sbRaw === "" ? NaN : Number(sbRaw);
        const at = Number.isFinite(sb) ? sb : base;
        want = fuelSurchargeLineFields(cfg, at, fuelSurchargeAmount(at, cfg.percent));
      } else {
        const amount = fuelSurchargeAmount(base, cfg.percent);
        if (state !== "open" || amount > 0) want = fuelSurchargeLineFields(cfg, base, amount);
      }
    }
    for (const l of fuel) {
      if (!want || l !== keep) out.deleteIds.push(l.id);
    }
    if (want) {
      out.after = { percent: want.fuelSurchargePercent, lineAmount: want.lineAmount, taxable: want.fuelSurchargeTaxable, categories: want.fuelSurchargeCategories, base: want.fuelSurchargeBase };
      if (!fuelSurchargeLineMatches(keep, want)) out.set = { id: keep ? keep.id : "fuel_surcharge", isNew: !keep, data: want };
    }
    out.changed = !!out.set || out.deleteIds.length > 0;
    return out;
  }

  // READERS. True for the server-owned surcharge line (any doc id: a forged
  // duplicate is still a surcharge line, and the server pass removes it).
  function isFuelSurchargeLine(line) {
    return !!line && typeof line === "object" && line.type === FUEL_SURCHARGE_TYPE;
  }

  // What a ticket's STORED lines bill for the surcharge, in whole cents. Readers
  // that report money (BI, the connector, exports) use this and never re-derive a
  // %, so they agree with the line the invoice prints and the header total.
  // A line hidden from the invoice (includeOnInvoice false) is not billed; the
  // server never writes one, so this only matters for a tampered line.
  // -> { amount, taxableAmount, count }
  function fuelSurchargeFromLines(lines) {
    let cents = 0;
    let taxableCents = 0;
    let count = 0;
    for (const l of (lines || [])) {
      if (!isFuelSurchargeLine(l) || l.includeOnInvoice === false) continue;
      const c = Math.round((Number(l.lineAmount) || 0) * 100);
      cents += c;
      if (l.fuelSurchargeTaxable === true) taxableCents += c;
      count += 1;
    }
    return { amount: cents / 100, taxableAmount: taxableCents / 100, count };
  }

  // The Price Book a ticket bills against: the one the clock-out picked, else the
  // contract the ticket's priced equipment came from. Null when neither exists.
  function ticketContractId(ticket, lines) {
    const ft = ticket && ticket.fieldTicketData;
    if (ft && typeof ft.contractId === "string" && ft.contractId) return ft.contractId;
    for (const l of (lines || [])) {
      if (l && l.type === "EQUIPMENT" && typeof l.contractId === "string" && l.contractId) return l.contractId;
    }
    return null;
  }

  // True when the tenant has turned the surcharge on anywhere (company default,
  // or any customer / Price Book override). False for every tenant that never
  // opened the setting — the common case, which must cost no transaction.
  function fuelSurchargeConfigured(fs) {
    if (!fs || typeof fs !== "object") return false;
    if (fs.mode === "flat") return true;
    const nonEmpty = (m) => !!m && typeof m === "object" && Object.keys(m).length > 0;
    return nonEmpty(fs.customers) || nonEmpty(fs.priceBooks);
  }

  window.FuelSurcharge = Object.freeze({
    FUEL_SURCHARGE_TYPE: FUEL_SURCHARGE_TYPE,
    FUEL_SURCHARGE_LINE_ID: FUEL_SURCHARGE_LINE_ID,
    FUEL_SURCHARGE_STAMP_COLLECTION: FUEL_SURCHARGE_STAMP_COLLECTION,
    FUEL_SURCHARGE_CATEGORY_KEYS: FUEL_SURCHARGE_CATEGORY_KEYS,
    normalizeFuelSurchargePercent: normalizeFuelSurchargePercent,
    normalizeFuelSurchargeConfig: normalizeFuelSurchargeConfig,
    resolveFuelSurchargeConfig: resolveFuelSurchargeConfig,
    fuelSurchargeBase: fuelSurchargeBase,
    fuelSurchargeAmount: fuelSurchargeAmount,
    fuelSurchargeMoneyText: fuelSurchargeMoneyText,
    fuelSurchargeDescription: fuelSurchargeDescription,
    fuelSurchargeTicketState: fuelSurchargeTicketState,
    fuelSurchargeLineFields: fuelSurchargeLineFields,
    fuelSurchargeLineMatches: fuelSurchargeLineMatches,
    planFuelSurcharge: planFuelSurcharge,
    isFuelSurchargeLine: isFuelSurchargeLine,
    fuelSurchargeFromLines: fuelSurchargeFromLines,
    ticketContractId: ticketContractId,
    fuelSurchargeConfigured: fuelSurchargeConfigured
  });
})();
